module.exports = __webpack_public_path__ + "static/media/image_logo_pinjia_grey.796073fb.png";